document.addEventListener('DOMContentLoaded', () => {
  const countryQuantityLimitModal = document.querySelector('.country-quantity-limit--modal');
  if (countryQuantityLimitModal != null) {
    const countryQuantityLimitModalButton = countryQuantityLimitModal.querySelector('.button');
    countryQuantityLimitModalButton.addEventListener('click', (e) => {
      e.preventDefault();

      countryQuantityLimitModal.remove();
    });

    const quantityFields = document.querySelectorAll('.product-quantity');
    if (quantityFields.length > 0) {
      quantityFields.forEach((quantityField) => {
        const quantityFieldNumber = quantityField.querySelector('[name="quantity"]');
        const quantityFieldNumberLimit = quantityFieldNumber.getAttribute('data-limit');

        if (quantityFieldNumberLimit != null) {
          const quantityFieldPlus = quantityField.querySelector('.product-quantity__plus');
          const quantityFieldNumberValue = quantityFieldNumber.value;

          quantityFieldNumber.addEventListener('change', (e) => {
            const field = e.currentTarget;
            if (parseInt(field.value) >= parseInt(quantityFieldNumberLimit)) {
              const countryQuantityLimitModalEl = document.querySelector('.country-quantity-limit--modal');
              if (countryQuantityLimitModalEl != null) {
                countryQuantityLimitModalEl.classList.remove('hidden');
              }
            }
          });
          
          quantityFieldPlus.addEventListener('click', (e) => {
            if (parseInt(quantityFieldNumberValue) >= parseInt(quantityFieldNumberLimit)) {
              const countryQuantityLimitModalEl = document.querySelector('.country-quantity-limit--modal');
              if (countryQuantityLimitModalEl != null) {
                countryQuantityLimitModalEl.classList.remove('hidden');
              }
            }
          });
        }
      });
    }
  }
});

// Låser HeroDesk-chatikonet fast i sin "nedrykkede" position — den placering
// HeroDesk selv giver det under 402px (right: -10px, bottom: -12px på iframen
// #herodesk-livechat) — på alle mobilstørrelser. Så hopper ikonet ikke op når
// HeroDesks egen collision-logik skifter mening ved 402/403px.
// Kun når chatten er lukket (lille iframe) — åben chat styres af HeroDesk selv.
(() => {
  const PIN_RIGHT = '-10px';     // = ikonets placering under 402px
  const PIN_BOTTOM = '-12px';
  const CLOSED_MAX_HEIGHT = 200; // højere iframe = chatten er åben
  const MOBILE_MAX = 1023;       // KrownThemes .portable-breakpoint
  let scheduled = false;
  let observedFrame = null;
  let pinned = false;
  let bodyObserver = null;

  const update = () => {
    scheduled = false;
    const frame = document.getElementById('herodesk-livechat');
    if (frame == null) return;

    // HeroDesk genskriver selv iframens style (åbn/luk, collision-nudge) —
    // reagér på det og sæt vores position tilbage
    if (observedFrame !== frame) {
      observedFrame = frame;
      // Iframen er fundet — disconnect den brede body-observer og sæt en
      // smal style-observer op på selve iframen i stedet.
      if (bodyObserver) { bodyObserver.disconnect(); bodyObserver = null; }
      new MutationObserver(schedule).observe(frame, { attributes: true, attributeFilter: ['style'] });
    }

    const isOpen = frame.getBoundingClientRect().height > CLOSED_MAX_HEIGHT;
    const shouldPin = !isOpen && window.innerWidth <= MOBILE_MAX;

    if (shouldPin) {
      // Skriv kun ved afvigelse — ellers looper attribut-observeren
      if (frame.style.getPropertyValue('right') !== PIN_RIGHT) {
        frame.style.setProperty('right', PIN_RIGHT, 'important');
      }
      if (frame.style.getPropertyValue('bottom') !== PIN_BOTTOM) {
        frame.style.setProperty('bottom', PIN_BOTTOM, 'important');
      }
      pinned = true;
    } else if (pinned) {
      // Åben chat / desktop: giv styringen tilbage til HeroDesk
      frame.style.removeProperty('right');
      frame.style.removeProperty('bottom');
      pinned = false;
    }
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('resize', schedule);
  // Fanger at iframen injiceres asynkront af HeroDesk. Observer kun direkte
  // children af body (HeroDesk injecter iframen dér) — subtree: true på
  // document.documentElement ville affyre på enhver DOM-mutation på hele siden.
  bodyObserver = new MutationObserver(schedule);
  bodyObserver.observe(document.body, { childList: true, subtree: false });
  schedule();
})();
